import React, {useContext, useEffect, useState} from 'react';
import Shipment from "./Shipment";
import TemporaryReceipt from "./TemporaryReceipt";
import Signature from "./Signature";
import RelationShipAddress from "./RelationShipAddress";
import PaymentByCheques from "./PaymentByCheques";
import Document from "./Document";
import Products from "./Products";
import PurchaseRequest from "./PurchaseRequest";
import ProductDisplay, {ProductDisplayCondition} from "./ProductDisplay";
import ProductsStock from "./ProductsStock";
import ProductsBarcode from "./ProductsBarcode";
import ProductsSerialNumber from "./ProductsSerialNumber";
import POS, {POSHistory, POSDialyReport} from "./POS";
import POSCrateBill from "./POSCrateBill";
import POSCustomer from "./POSCustomer";
import StockAdjustment from "./StockAdjustment";
import './index.css';
import {Link, Route, Switch, useLocation} from "react-router-dom";
import ProductStock from "./ProductStock";
import User from "./User";
import ShipmentStockTransfer from "./ShipmentStockTransfer";
import FileUploadAudit from "./FileUploadAudit";
import {RelationshipGroupListExcel} from "./RelationshipGroupListExcel";
import ProductChartOfAccount from "./ProductChartOfAccount";
import {AppContext} from "./AppProvider";
import Relationship from "./Relationship";
import ProductStockLastHistory from "./ProductStockLastHistory";

// import AiData from "./AiData";

function App() {
	const app = useContext(AppContext)
	const [user, setUser] = useState(false);
	// const [token, setToken] = useState(
	// 	window.Global.getCookie('user')
	// 	&& window.Global.getCookie('user') !== '' ?
	// 		JSON.parse(window.Global.getCookie('user')).token
	// 		: false
	// );

	let monitor = () => {
		if (!window.user) return;
		console.log('ready');
		// window.Global.monitor({
		// 	url: 'wss://' + process.env.REACT_APP_HOST + '/websocket',
		// 	user: {
		// 		name: window.user.name,
		// 		email: window.user.email,
		// 		company: {
		// 			name: window.user.company.company_name
		// 		},
		// 		current_branch: {
		// 			name: window.user.current_branch.name
		// 		},
		// 		is_admin: false
		// 	}
		// });
	}

	const location = useLocation();
	React.useEffect(() => {
		// console.log('Location changed');
		monitor();
	}, [location]);

	window.setUser = setUser;
	// window.setToken = setToken;
	// if (process.env.NODE_ENV === "development") {
	// 	window.Global.ajax = (object) => {
	// 		if (typeof (object.method) == 'undefined')
	// 			object.method = 'POST';
	// 		if (typeof (object.dataType) == 'undefined')
	// 			object.dataType = 'json';
	// 		if (typeof (object.contentType) == 'undefined')
	// 			object.contentType = 'application/x-www-form-urlencoded; charset=UTF-8';
	// 		if (object.data) {
	// 			//object.data.api_key = '3WEgGuFJpPedJX84sbAzaWxv';
	// 		} else {
	// 			object.data = {};
	// 		}
	//
	// 		let headers = object.headers ? object.headers : {};
	// 		let $header = window.$('meta[name="csrf-token"]');
	// 		if ($header.length) {
	// 			headers['X-CSRF-TOKEN'] = $header.attr('content');
	// 		}
	// 		if (process.env.REACT_APP_MODE === "DEV") {
	// 			window.Global.createCookie('user', "{\"token\":\"BTUaMsABx0L4w1yLGQwNSv1PcJmIrOMtAvTo0rvVoX1n4VfuMNnIUjVep8OWJ0Y3Km3p2YxDcR2dWsubpg1GMvy16lIBmPpdjAsUu1SFU03azEW4xFPXREgd062RXdjYyZ2M6VgmjnkDhbstfA9NY0tgOEz3YTHPWG7X2RwbDuWlyjQq4EVSOxhD5Z3YlKRBValsyOIgWOiqahRXAOAJibAgkuSQ0FwjUT4v9pikHolUzgtL6RguZ8bTQbaiHLI\",\"user\":{\"id\":8,\"user_id\":8,\"image_filename\":\"\",\"name\":\"นายค้าขาย ร่ำรวย\",\"email\":\"account_for_testing_001@test.com\",\"code\":null,\"national_id\":null,\"tax_number\":null,\"branch_id\":1,\"address\":\"121\",\"district\":\"แม่กรณ์\",\"amphoe\":\"เมืองเชียงราย\",\"province\":\"เชียงราย\",\"zipcode\":\"57000\",\"phone\":[\"231541213\"],\"user_job_profile_id\":null,\"is_working\":1,\"working_start_date\":null,\"working_probation_end_date\":null,\"working_end_date\":null,\"salary_start\":\"0.0000\",\"salary_start_after_probation\":\"0.0000\",\"remark\":null,\"is_owner_company\":1,\"cash_hold\":\"-1067807.1500\",\"hold_cash_advance\":\"0.0000\",\"permission_product\":\"read_write\",\"permission_relationship\":\"read_write\",\"permission_sale_order\":\"read_write\",\"permission_sale_order_approve\":\"allow\",\"permission_purchase_order\":\"read_write\",\"permission_purchase_order_approve\":\"allow\",\"permission_purchase_order_see_creditor\":\"allow\",\"permission_can_see_cost\":\"0\",\"permission_stock_transfer\":\"read_write\",\"permission_stock_transfer_approve\":\"allow\",\"permission_requisition\":\"read_write\",\"permission_user\":\"read_write\",\"permission_setting\":\"read_write\",\"permission_purchase_order_payment\":\"read_write\",\"permission_purchase_order_shipment\":\"read_write\",\"permission_sale_order_payment\":\"read_write\",\"permission_sale_order_shipment\":\"read_write\",\"permission_sale_order_invoice\":\"read_write\",\"permission_stock_adjustment\":\"read_write\",\"permission_stock_adjustment_approve\":\"allow\",\"permission_modify_payment_document_type\":1,\"permission_modify_payment_item\":1,\"permission_dashboard\":1,\"permission_purchase_order_item_discount_subtract\":1,\"is_deleted\":0,\"updated_user_id\":25,\"created_user_id\":null,\"date_updated\":\"2020-10-15 10:19:53\",\"date_created\":\"2018-08-08 09:22:18\",\"user_image_file_upload\":{\"url\":\"https://dev.b49erp.com/storage/image.png\"},\"date\":\"2020-10-20 09:47:38\",\"address2\":\"121 ต.แม่กรณ์ จ.เชียงราย 57000\",\"leave\":[],\"user_permission\":{\"id\":2,\"user_id\":8,\"is_can_approve_sale_order_quotation\":1,\"is_can_edit_payment\":1},\"company\":{\"company_name\":\"บริษัท บีโฟร์ไนน์ คอนเซ็าท์ แทนซี่ จำกัด\",\"is_disabled\":0,\"company_feature_permission\":{\"id\":1,\"company_id\":8,\"is_can_access_longan_industry\":1,\"max_branch_number\":10,\"validate\":1,\"stock\":1,\"finance\":1,\"activity\":1,\"sale\":1,\"purchase\":1,\"is_mobile_app_can_access_purchase_order\":1,\"is_mobile_app_can_access_bom_adjustment\":1,\"is_mobile_app_can_access_stock_transfer\":1,\"is_mobile_app_can_access_user_task\":1,\"is_mobile_app_can_access_user_task_leave\":1,\"is_mobile_app_can_access_shipment_requisition\":1,\"is_mobile_app_can_access_file_upload\":1,\"is_mobile_app_can_access_pos\":1,\"is_mobile_app_can_access_file_upload_audit\":1,\"is_mobile_app_can_access_temporary_receipt\":1}},\"current_branch\":{\"id\":1,\"name\":\"สำนักงานใหญ่\",\"code\":\"0000\",\"bill_line_1\":\"181/96 ต.ช้างเผือก อ.เมืองเชียงใหม่ จ.เชียงใหม่ 50300\",\"bill_line_2\":\"โทร 052-555649\",\"is_deleted\":0,\"is_tax_invoice_when_pay_in\":0,\"is_shipment_when_pay_in\":1,\"is_shipment_complete_when_pay_in\":1,\"updated_user_id\":8,\"created_user_id\":null,\"date_updated\":\"2020-09-27 01:07:52\",\"date_created\":\"2018-08-08 09:22:18\"}},\"success\":true}");
	// 			headers.Authorization = '84cb5b7a9e9f13b0ea71dd983d82d749d0e104c932f62df4f677c5a07df656fc862fe04feea6edb6d4432c5a2a1d03fff3ad455a94fce3ddea39b439dcaa8a14';
	// 		}
	//
	// 		return window.$.ajax({
	// 			type: object.method,
	// 			data: object.data,
	// 			contentType: object.contentType,
	// 			url: object.url,
	// 			headers: headers,
	// 			beforeSend: function () {
	// 				if (typeof (object.beforeSend) != 'undefined') {
	// 					object.beforeSend();
	// 				}
	// 			},
	// 			dataType: object.dataType
	// 		}).done(function (response, textStatus, jqXHR) {
	// 			// if (typeof window.delayTakeScreen === 'undefined') {
	// 			// 	window.delayTakeScreen = false;
	// 			// }
	// 			//
	// 			// console.log(response.log_screen);
	// 			// console.log(window.delayTakeScreen);
	// 			// console.log(typeof html2canvas);
	// 			//
	// 			// if (response.log_screen
	// 			// 	&& window.delayTakeScreen === false
	// 			// 	&& typeof html2canvas !== 'undefined'
	// 			// ) {
	// 			// 	try {
	// 			// 		window.delayTakeScreen = true;
	// 			// 		window.Global.isDebugScreen(
	// 			// 			{
	// 			// 				token: response.log_screen.token,
	// 			// 				beforeCapture: function () {
	// 			// 					window.$("#template_1").css({
	// 			// 						position: 'relative',
	// 			// 						height: 'initial'
	// 			// 					});
	// 			// 					window.$("body,html").css({
	// 			// 						height: 'initial'
	// 			// 					});
	// 			// 				},
	// 			// 				afterCapture: function () {
	// 			// 					window.$("#template_1").css({
	// 			// 						position: 'absolute',
	// 			// 						height: '100%'
	// 			// 					});
	// 			// 					window.$("body,html").css({
	// 			// 						height: '100%'
	// 			// 					});
	// 			// 				},
	// 			// 				onSuccess: function () {
	// 			// 					window.delayTakeScreen = false;
	// 			// 				}
	// 			// 			}
	// 			// 		)
	// 			// 	} catch (e) {
	// 			//
	// 			// 	}
	// 			// }
	//
	// 			if (response.error && response.message) {
	// 				window.$.each(response.message, function (i, message) {
	// 					if (message['is_require_authentication'] && (object.data && !object.data.disableSignOut)) {
	// 						window.location = '/signout';
	// 						return false;
	// 					}
	// 				})
	// 			}
	// 			if (typeof object.done == 'function')
	// 				object.done(response);
	// 		}).fail(function (jqXHR, textStatus, errorThrown) {
	// 			if (typeof object.fail == 'function')
	// 				object.fail(jqXHR);
	// 		});
	// 	};
	// }
	useEffect(() => {
		window.fetchUserData({
			onDone: (response) => {
				app.setUser(prevState => ({
					...prevState,
					user: response.user[0]
				}))

				setUser(response.user[0]);

				monitor();
			}
		})
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	window.GlobalFunc.listenerScanBarcode({
		key: 'react_version_b49erp_com',
		onScanBarcode: (e) => {
			let event = window.$.Event("onScanBarcode");
			event.barcode = e.barcode
			window.$(document).trigger(event);
		}
	})

	if (user) {
		let is_can_use_backend_website = window.user.company.company_feature_permission.is_can_use_backend_website === 0;
		let home_url = '/v2/products';

		if (is_can_use_backend_website) {
			home_url = '/v2/file-upload-audit';
		}

		return (
			<div>
				<div className="flex row"
				     id="template_1"
				     style={{position: 'absolute', height: '100%', width: '100%', overflow: 'hidden'}}
				     ref={() => {
					     if (window.loadGlobalNotification) {
						     return;
					     }
					     setTimeout(function () {
						     window.GlobalFunc.getCountNotification();
						     window.GlobalFunc.initMenu();

						     window.Route.setupMenu(
							     window.$('.SliderMenu_root .fix-click-menu')
						     );

						     window.loadGlobalNotification = true;
					     }, 2000);

					     if (is_can_use_backend_website) {
						     window.$('.SliderMenu_root > .item').each(function () {
							     if (window.$(this).attr('href') === '/v2/file-upload-audit') {
								     return false;
							     }
							     window.$(this).remove();
						     });

						     window.$('#setting-menu').remove();
						     window.$('#edit-profiles').removeAttr('href');
					     }
				     }}>
					<div className="slide-menu-root">
						<div className="SliderMenu_root">
							<div id="LogoSetting_root" className="flex row middle-xs">
								<div className="flex lg:flex-col flex-row w-full">
									<div className="flex flex-row overflow-hidden leading-[1.3] mt-[0.3rem]">
										<div className="shrink-0">
											<Link to={home_url}>
												<img src={process.env.REACT_APP_DOMAIN + "/assets/images/logo.png"} alt=""/>
											</Link>
										</div>
										<div className="grid shrink">
											<Link to={home_url}>
												<b style={{color: 'gold'}}>B49 ERP</b>
											</Link>
											<a className="name truncate block text-left text-white text-xs"
											   href="/#"
											   id="user-current-name">&nbsp;</a>
										</div>
									</div>
									<div>
										<div className="mt-0 lg:mt-3 ml-2 lg:ml-0 text-[#bdbdbd] cursor-pointer text-[0.9rem]">
											<div id="change-branch-button"
											     className="branch"
											     data-tooltip="กดเปลี่ยนสาขา"
											     data-position="bottom left"
											     onClick={() => {
												     window.LogoSetting.switchBranch();
											     }}
											>
												<div id="user-current-company-name" className="truncate text-white"></div>
												<div id="user-current-company-branch-name" className="truncate text-xs mt-1"></div>
											</div>
										</div>
									</div>
									<div id="mobile-menu" className="right floated flex row middle-xs mobile-menu">
										<div className="">
											<i className="ui align justify icon"></i>
										</div>
									</div>
								</div>
							</div>
							<a className="item flex row between-xs middle-xs dashboard-page"
							   style={{display: 'none'}}
							   href={process.env.REACT_APP_DOMAIN + "/dashboard"}
							   data-menu="true"
							   data-no_navigo="">
								<div>
									<i className="bar chart icon"/>&nbsp;<b>สุขภาพบริษัท</b>
								</div>
							</a>
							<a className="item flex row between-xs middle-xs purchase-page"
							   style={{
								   display: 'none'
							   }}
							   href={process.env.REACT_APP_DOMAIN + "/purchase_orders"}
							   data-menu="true"
							   data-no_navigo="">
								<div>
									<i className="tags icon"/>&nbsp;<b>ซื้อ/จ่าย</b>
								</div>
								<span data-menu="true"
								      data-href="/payments/new?method=pay_out&is_express=1"
								      className="ui label mini red menu-mini fix-click-menu"
								      data-tooltip="POS"
								      data-inverted=""
								      style={{
									      color: 'rgba(0,0,0,.8)'
								      }}>ด่วน
								</span>
							</a>
							<div className="item sale-page" style={{display: 'none'}}>
								<div className="flex row between-xs middle-xs">
									<div><i className="plus square icon"/>&nbsp;<b>ขาย</b></div>
									<a data-menu="true"
									   href={process.env.REACT_APP_DOMAIN + "/payments/new?method=pay_in&is_express=1"}
									   data-tooltip="POS"
									   data-inverted=""
									   className="ui label mini red menu-mini"
									   style={{color: 'rgba(0,0,0,.8)'}}>ด่วน</a>
								</div>
								<div className="menu">
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/sale_orders"}
									   data-menu="true">
                        <span className="flex row middle-xs">
                            ใบขายสินค้า
                        </span>
									</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/sale_order_quotation"}
									   data-menu="true">ใบเสนอราคา</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/invoices"}
									   data-menu="true">ใบแจ้งหนี้</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/contacts"}
									   data-menu="true">สัญญารายเดือน</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/sale-order-invoice-rounds"}
									   data-menu="true">ใบแจ้งหนี้ประจำเดือน</a>
								</div>
							</div>
							<div className="item">
								<i className="handshake icon"/><b>การเงิน</b>
								<div className="menu">
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/payments"}>ความเคลื่อนไหวการเงิน</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/payments?method=deposit_out"}>มัดจำซื้อ</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/payments?method=deposit_in"}>มัดจำขาย</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/petty-cash"}
									   data-menu="true">เงินสดย่อย</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/cash-advance"}
									   data-menu="true">เงินทดรองจ่าย</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/debit-credit-notes?type=debit_note,credit_note"}>ใบเพิ่มหนี้/ลดหนี้</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/payments?document_type=payment_voucher"}>ใบสำคัญจ่ายเงิน</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/payments?document_type=receipt_voucher"}>ใบสำคัญรับเงิน</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/advance-payment?type=receive_advance_payment"}>รับเงินล่วงหน้า</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/advance-payment?type=pay_advance_payment"}>จ่ายเงินล่วงหน้า</a>
								</div>
							</div>
							<div className="item">
								<i className="cubes icon"/><b>กิจกรรม</b>
								<div className="menu">
									{/*<Link className={"item"} to={"/v2/shipments"}>ความเคลื่อนไหวสินค้า</Link>*/}
									<Link className={"item"}
									      to={"/v2/shipments"}>ความเคลื่อนไหวสินค้า
									</Link>
									<span className="item flex row middle-xs menu-notification">
	                            <span id="menu-count-stock-alert" className="count"/>
	                            <Link to={"/v2/product-stock"}
	                                  data-menu="true"
	                                  className="item">ตรวจสอบยอดคงเหลือ</Link>
	                        </span>
									<span className="item flex row middle-xs menu-notification">
										<span className="count"/>
	                            <Link to={"/v2/product-stock-last-history"}
	                                  data-menu="true"
	                                  className="item flex relative">
		                            จำนวนวันไม่เคลื่อนไหว
	                            </Link>
	                        </span>
									<span className="item flex row middle-xs menu-notification">
	                            <span id="menu-count-stock-transfer-draft" className="count"/>
	                            <Link to={"/v2/stock_transfers"}
	                                  data-menu="true"
	                                  className="item stock-transfer-page"
	                                  style={{display: 'none'}}
	                            >โอนย้ายระหว่างคลัง</Link>
	                        </span>
									<Link className="item stock-adjustment-page"
									      to={"/v2/stock_adjustment"}
									      style={{display: 'none'}}
									>ปรับสินค้าคงคลัง</Link>
									<Link className="item requisition-page"
									      style={{display: 'none'}}
									      to={"/v2/requisition?source=requisition&requisition_method=borrow"}
									>เบิกใช้สินค้า</Link>
									<Link className="item requisition-page"
									      style={{display: 'none'}}
									      to={"/v2/requisition?source=requisition&requisition_method=return"}
									>คืนสินค้า</Link>
									<Link className="item flex row between-xs middle-xs"
									      to={"/v2/serial-number"}
									>
										<span>ซีเรียลนัมเบอร์</span>
										<span className="ui label mini red menu-mini"
										      style={{color: 'rgba(0,0,0,.8)'}}>ใหม่</span>
									</Link>
									<span className="item flex row middle-xs menu-notification">
			                        <span id="menu-shipment_between_branch_request_wait_processing" className="count"/>
			                        <a href={process.env.REACT_APP_DOMAIN + "/shipments?source=between_branch&method=request"}
			                           data-menu="true"
			                           className="item">ขอสินค้าระหว่างสาขา</a>
			                    </span>
									<span className="item flex row middle-xs menu-notification">
			                        <span id="menu-shipment_between_branch_deliver_processing" className="count"/>
			                        <a href={process.env.REACT_APP_DOMAIN + "/shipments?source=between_branch&method=deliver"}
			                           data-menu="true"
			                           className="item">ส่งสินค้าระหว่างสาขา</a>
			                    </span>
									<span className="item flex row middle-xs menu-notification">
			                        <span id="menu-shipment_between_branch_receive_draft" className="count"/>
			                        <a href={process.env.REACT_APP_DOMAIN + "/shipments?source=between_branch&method=receive"}
			                           data-menu="true"
			                           className="item">รับสินค้าระหว่างสาขา</a>
			                    </span>
									<span className="item flex row middle-xs menu-notification">
			                        <span id="menu-shipment_between_branch_return_draft" className="count"/>
			                        <a href={process.env.REACT_APP_DOMAIN + "/shipments?source=between_branch&method=return"}
			                           data-menu="true"
			                           className="item">คืนสินค้าระหว่างสาขา</a>
			                    </span>
								</div>
							</div>
							<div className="item">
								<i className="sticky note outline icon"/><b>วิธีชำระเงิน</b>
								<div className="menu">
									<a className="item flex row between-xs middle-xs"
									   href={process.env.REACT_APP_DOMAIN + "/payment-by-bank-transfer-draft?status=wait-processing"}
									   data-menu="true">
										<span>แจ้งการโอนเงิน</span>
									</a>
									<a className="item flex row between-xs middle-xs"
									   href={process.env.REACT_APP_DOMAIN + "/payment-by-cash-on-delivery"}
									   data-menu="true">
										<span>เก็บเงินปลายทาง</span>
									</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/verify-cash"}
									   data-menu="true">เงินสด</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/setting/bank"}
									   data-menu="true">ธนาคาร</a>
									<Link className="item" to="/v2/payment-by-cheques">เช็ครับ-เช็คจ่าย</Link>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/credit_card_checking"}
									   data-menu="true">บัตรเครดิต</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/debts?is_paid=0&is_expired=0&limit=50"}
									   data-menu="true">ติดตามหนี้</a>
								</div>
							</div>
							<div className="item">
								<i className="industry icon"/><b>การผลิต/แปรรูปสินค้า</b>
								<div className="menu">
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/machines"}
									   data-menu="true">เครื่องผลิตสินค้า</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/bom_adjustment"}
									   data-menu="true">ประวัติ</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/shipment-bom-adjustment-activity"}
									   data-menu="true">กระบวนการผลิต</a>
								</div>
							</div>
							<div className="item active-hover-style">
								<div className="flex row between-xs middle-xs">
									<a data-menu="true" href={process.env.REACT_APP_DOMAIN + "/dashboard"}>
										<i className="chart pie icon"/>&nbsp;<b>รายงาน</b>
									</a>
									<span data-menu="sub">
									<i className="chevron circle down icon" style={{marginRight: 0}}/>
								</span>
								</div>
								<div className="menu">
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/reports?method=sale-tax&is_also_deleted=1&is_tax_doc=1"}>ภาษีขาย</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/reports?method=purchase-order-tax&is_also_deleted=1&is_tax_doc=1"}>ภาษีซื้อ</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/payment-withholding-tax?source=buy"}>ภาษีหัก
										ณ
										ที่จ่าย</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/payment-withholding-tax?source=sell"}>ภาษีถูกหัก
										ณ
										ที่จ่าย</a>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/reports?method=product-movement"}>เคลื่อนไหวสินค้ารายวัน</a>
									<div id="download-excel-report" className="item">ดาวน์โหลด</div>
								</div>
							</div>
							<div className="item">
								<div className="flex row between-xs middle-xs">
									<div><i className="plus square icon"/>&nbsp;<b>ฟีเจอร์ใหม่</b></div>
									<span data-tooltip="อยู่ระหว่างทดลองใช้"
									      data-inverted=""
									      className="ui label mini red menu-mini"
									      style={{color: 'rgba(0,0,0,.8)'}}>beta</span>
								</div>
								<div className="menu">
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/users/task/calendar"}
									   data-menu="true">
										<span className="flex row middle-xs">ปฏิทินงาน</span>
									</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/users/task"}
									   data-menu="true">งาน</a>
									<a className="item salary-page"
									   href={process.env.REACT_APP_DOMAIN + "/salary"}
									   data-menu="true"
									   style={{display: 'none'}}
									>
										เงินเดือน
									</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/user-job-profiles"}
									   data-menu="true">Job Profiles</a>
									{/*<a className="item" href={process.env.REACT_APP_DOMAIN + "/form"}*/}
									{/*   data-menu="true">แบบฟอร์ม</a>*/}
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/product-display"}>E-Commerce</a>
									<Link className="item" to={"/v2/temporary-receipts"}>ใบเสร็จรับเงินชั่วคราว</Link>
									<Link className="item" to={"/v2/my-signature"}>ลายเซ็น</Link>
									{/*<Link className={"item"} to={"/v2/purchase-request"}>ระบบจัดซื้อ</Link>*/}
									{/*<Link className={"item"} to={"/v2/ai-data"}>Artificial Intelligence Analyzing Data</Link>*/}
								</div>
							</div>
							<div className="item">
								<i className="user icon"/><b>ทะเบียน</b>
								<div className="menu">
									{/*<a className="item relationship-page"*/}
									{/*   href={process.env.REACT_APP_DOMAIN + "/relationships"}*/}
									{/*   style={{display: 'none'}}*/}
									{/*   data-menu="true">*/}
									{/*	ลูกค้าและเจ้าหนี้*/}
									{/*</a>*/}
									<Link className="item relationship-page"
									      to={"/v2/relationships"}
									      style={{display: 'none'}}>
										ลูกค้าและเจ้าหนี้
									</Link>
									<a className="item"
									   href={process.env.REACT_APP_DOMAIN + "/relationship/group"}
									   data-menu="true">
										กลุ่มลูกค้า
									</a>
									<Link className="item product-page"
									      to={"/v2/products"}
									      style={{display: 'none'}}>
										สินค้า
									</Link>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/product_templates"}
									   data-menu="true">กิจกรรมประจำ</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/purchase-order-activity"}
									   data-menu="true">กิจกรรมประจำการซื้อ</a>
									<a className="item user-page"
									   href={process.env.REACT_APP_DOMAIN + "/users"}
									   style={{display: 'none'}}
									   data-menu="true">พนักงาน</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/teams"}
									   data-menu="true">ทีมและฝ่าย</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/projects"}
									   data-menu="true">โครงการ</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/permission/payment_by"}
									   data-menu="true">สิทธิ์ของลูกค้า</a>
									<a className="item" href={process.env.REACT_APP_DOMAIN + "/pos"}
									   data-menu="true">POS</a>
								</div>
							</div>
							<Link className="item" to={"/v2/file-upload-audit"}>
								<i className="file alternate outline icon"/><b>อัพโหลดเอกสาร</b>
							</Link>
							<a id={"setting-menu"}
							   className="item setting-page"
							   href={process.env.REACT_APP_DOMAIN + "/setting/company_info"}
							   style={{display: 'none'}}
							   data-menu="true">
								<i className="setting icon"/><b>ตั้งค่า</b>
							</a>
							<a className="item" href={process.env.REACT_APP_DOMAIN + "/signout"}>
								<i className="sign out icon"/><b>ลงชื่อออก</b>
							</a>
						</div>
					</div>
					<div id="Root" className="Wrapper_root">
						<Switch>
							<Route path="/v2/temporary-receipts"
							       component={TemporaryReceipt}
							/>
							<Route path="/v2/temporary-receipts/:temporary_receipt_id"
							       component={TemporaryReceipt}
							/>
							<Route path="/v2/my-signature"
							       component={Signature}
							/>
							<Route path="/v2/my-signature/new"
							       component={Signature}
							/>
							<Route path="/v2/my-signature/:signature_id"
							       component={Signature}
							/>
							<Route path="/v2/my-signature/:signature_id/edit"
							       component={Signature}
							/>
							<Route path="/v2/settings/documents"
							       component={Document}
							/>
							<Route path="/v2/settings/documents/new"
							       component={Document}
							/>
							<Route path="/v2/settings/documents/:document_id"
							       component={Document}
							/>
							<Route path="/v2/settings/documents/:document_id/edit"
							       component={Document}
							/>
							<Route path="/v2/product-display"
							       component={ProductDisplay}
							/>
							<Route path="/v2/product-display/:product_display_id"
							       component={ProductDisplay}
							/>
							<Route path="/v2/product-display-permission/:product_display_condition_id"
							       component={ProductDisplayCondition}
							/>
							<Route path="/v2/relationships/address"
							       component={RelationShipAddress}
							/>
							<Route path="/v2/payment-by-cheques"
							       component={PaymentByCheques}
							/>
							<Route path="/v2/products/:product_id/serial-number"
							       component={ProductsSerialNumber}
							/>
							<Route path="/v2/serial-number"
							       component={ProductsSerialNumber}
							/>
							<Route path="/v2/products/:product_id/barcode"
							       component={ProductsBarcode}
							/>
							<Route path="/v2/products/:product_id/stock"
							       component={ProductsStock}
							/>
							<Route path="/v2/products/:product_id/chart_of_account"
							       component={ProductChartOfAccount}
							/>
							<Route path="/v2/products/:product_id"
							       component={Products}
							/>
							<Route path="/v2/products"
							       component={Products}
								// render={() => <Products/>}
							/>
							<Route path="/v2/purchase-request/:product_request_id/edit" component={PurchaseRequest}/>
							<Route path="/v2/purchase-request/:product_request_id" component={PurchaseRequest}/>
							<Route path="/v2/purchase-request/new" component={PurchaseRequest}/>
							<Route path="/v2/purchase-request" component={PurchaseRequest}/>
							<Route path="/v2/sale_orders/pos/create-bill" component={POSCrateBill}/>
							<Route path="/v2/sale_orders/pos/history" component={POSHistory}/>
							<Route path="/v2/sale_orders/pos/daily-report" component={POSDialyReport}/>
							<Route path="/v2/sale_orders/pos/customer" component={POSCustomer}/>
							<Route path="/v2/sale_orders/pos" component={POS}/>
							<Route path="/v2/stock_adjustment/:stock_adjustment_id/edit" component={StockAdjustment}/>
							<Route path="/v2/stock_adjustment/:stock_adjustment_id" component={StockAdjustment}/>
							<Route path="/v2/stock_adjustment" component={Shipment}/>
							<Route path="/v2/requisition" component={Shipment}/>
							<Route path="/v2/product-stock" component={ProductStock}/>
							<Route path="/v2/product-stock-last-history" component={ProductStockLastHistory}/>
							{/*<Route path="/v2/ai-data" component={AiData}/>*/}
							<Route path="/v2/users/:user_id/bank_book"
							       component={User}
							/>

							<Route path="/v2/stock_transfers/:shipment_id/edit" component={ShipmentStockTransfer}/>
							<Route path="/v2/stock_transfers/:shipment_id" component={ShipmentStockTransfer}/>
							<Route path="/v2/stock_transfers/new" component={ShipmentStockTransfer}/>
							<Route path="/v2/stock_transfers" component={Shipment}/>
							<Route path="/v2/shipments" component={Shipment}/>

							<Route path="/v2/file-upload-audit"
							       component={FileUploadAudit}
							/>
							<Route path="/v2/relationship/group/:relationship_group_id/import"
							       component={RelationshipGroupListExcel}
							/>
							<Route path="/v2/relationships"
							       component={Relationship}
							/>
						</Switch>
					</div>
				</div>
			</div>
		)
	}
	return null;
}


export default App
